import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IDataSourceDetailInfo } from '../../../../ts/models/IDataSourceInfo';
import { ContentActionsService } from '../../../../commonInfra/contentActions/ContentActions';
import { getSessionManagementServiceInstance } from '../../../../sessionManagement/SessionManagementService';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { getDatasourceDetailInfo, openBlankWindow, replaceDatasourceIdWithConnectionIdForMixedContent } from '../SpacesSagaHelpers';
import { EditDatasourceAction } from '../../../actions/spaces/EditDatasourceAction';

// When a new window is created, if it's not part of a click event handler it will be detected by browsers as a pop-up.
// Because we are opening a new window in the edit workbook saga which is async, to get around the pop up blocker we need
// to open the window first, then the window.location.href can be set asynchronously afterwards

export function* handleNewWorkbookForEditDatasourceAction(action: EditDatasourceAction): SagaIterator {
  let newWindow: Window = null;
  try {
    newWindow = openBlankWindow();
    const mutatableContentInfo: IContentInfo[] = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, [action.contentInfo]);
    const datasourceDetailInfo: IDataSourceDetailInfo = yield call(getDatasourceDetailInfo, mutatableContentInfo[0].id);

    // Sanity check, we can only edit published datasources
    if (datasourceDetailInfo.contentType !== 'datasource' ||  !!datasourceDetailInfo.workbook) {
      throw new Error('Only published data sources can be edited');
    }

    createNewWorkbookForEditDatasource(datasourceDetailInfo, newWindow);
  } catch(e) {
    newWindow && newWindow.close();
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function createNewWorkbookForEditDatasource(datasourceDetailInfo: IDataSourceDetailInfo, newWindow: Window) {
  const contentActionsService = ContentActionsService;
  const sessionManagementService = getSessionManagementServiceInstance();
  newWindow.location.href = contentActionsService.generateTempWorkbookFromDatasourceUrlForEdit(datasourceDetailInfo, sessionManagementService.sessionSiteUrlName());
}
